export const uiSchema = {
  "type": "VerticalLayout",
  "elements": [
    {
      "type": "Control",
      "scope": "#/properties/name",
      "label": "Name"
    },
    {
      "type": "Control",
      "scope": "#/properties/props",
      "label": "Parameters to display"
    }
  ]
}